import { render, staticRenderFns } from "./CustomIcon.vue?vue&type=template&id=bcb929ac&scoped=true"
import script from "./CustomIcon.vue?vue&type=script&lang=js"
export * from "./CustomIcon.vue?vue&type=script&lang=js"
import style0 from "./CustomIcon.vue?vue&type=style&index=0&id=bcb929ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb929ac",
  null
  
)

export default component.exports